import type { OrderStateCard } from '../components/details/types'

/**
 * Drop the return link from `active_orders` cards the order-history API says
 * can no longer be returned.
 *
 * The trait picks that CTA from where the parcel ended up, which is not enough
 * on its own: a delivered order can be past its return window, already
 * returned, or non-returnable by nature. `canReturn` on the order payload is
 * the only authority on that, and it is what the Manage order return button
 * already follows — so the two now agree instead of contradicting each other.
 *
 * Only the return CTA is gated; every other action stays as the host sent it.
 */
export function applyReturnEligibility(
  cards: OrderStateCard[],
  canReturn: boolean,
): OrderStateCard[] {
  if (canReturn) return cards

  return cards.map((card) =>
    card.cta?.kind === 'returnOrExchange' ? { ...card, cta: null } : card,
  )
}
